import { createClient } from '@supabase/supabase-js';
import { Database } from './types.js';

// Global variables injected by Vite define
declare const __SUPABASE_URL__: string | undefined;
declare const __SUPABASE_ANON_KEY__: string | undefined;

// These environment variables should be set in your application's .env file
// We check for the injected global first, then fall back to import.meta.env
const supabaseUrl = typeof __SUPABASE_URL__ !== 'undefined' ? __SUPABASE_URL__ : import.meta.env.VITE_SUPABASE_URL;
const supabaseKey = typeof __SUPABASE_ANON_KEY__ !== 'undefined' ? __SUPABASE_ANON_KEY__ : import.meta.env.VITE_SUPABASE_ANON_KEY;

console.log('Supabase Client Init:', {
  urlProvided: !!supabaseUrl,
  keyProvided: !!supabaseKey,
  urlType: typeof supabaseUrl,
  globalUrl: typeof __SUPABASE_URL__ !== 'undefined' ? 'defined' : 'undefined',
  metaUrl: !!import.meta.env.VITE_SUPABASE_URL
});

if (!supabaseUrl || !supabaseKey) {
  console.error('Supabase URL or Key is missing!', { supabaseUrl, supabaseKey });
}

export const supabase = createClient<Database>(
  supabaseUrl || '',
  supabaseKey || ''
);
